import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Menu, MenuItem } from './va-menu';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      hr {
        width: unset;
        margin: 0;
        border: 0;
        border-top: 1px solid #e0e0e0;
      }
      ::ng-deep .mat-mdc-menu-content {
        padding-top: unset;
        padding-bottom: unset;
      }
      .menu-item {
        display: flex;
        align-items: center;
      }
      span.menu-item-text {
        flex-grow: 1;
      }
      mat-icon.right-icon {
        margin-right: 0;
      }
      .container {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    `,
  ],
  template: `
    <div class="container">
      <span *ngIf="title">{{ title }}</span>
      <button mat-icon-button [matMenuTriggerFor]="menuRef" color="primary">
        <mat-icon>{{ triggerIcon }}</mat-icon>
      </button>
    </div>
    <mat-menu #menuRef="matMenu">
      <ng-container *ngFor="let menu of config.menuItems">
        <hr *ngIf="menu.showTopDivider" />
        <button
          *ngIf="!menu.link"
          mat-menu-item
          class="menu-item"
          [disabled]="menu.disabled"
          [attr.data-pendo]="menu.pendo"
          (click)="onClick(menu)"
          [glxyTooltip]="menu.toolTip || ''"
        >
          <mat-icon *ngIf="menu.leftIcon">{{ menu.leftIcon }}</mat-icon>
          <va-icon *ngIf="menu.leftIconImageUrl" [iconUrl]="menu.leftIconImageUrl" [iconName]="menu.text"></va-icon>
          <span class="menu-item-text">{{ menu.text }}</span>
          <mat-icon class="right-icon" *ngIf="menu.rightIcon">{{ menu.rightIcon }}</mat-icon>
        </button>
        <a
          *ngIf="menu.link && !menu.link.external"
          class="menu-item"
          [disabled]="menu.disabled"
          [routerLink]="menu.link.url"
          [target]="menu.link.target"
          [attr.data-pendo]="menu.pendo"
          (click)="onClick(menu)"
          [glxyTooltip]="menu.toolTip || ''"
          mat-menu-item
        >
          <mat-icon *ngIf="menu.leftIcon">{{ menu.leftIcon }}</mat-icon>
          <va-icon *ngIf="menu.leftIconImageUrl" [iconUrl]="menu.leftIconImageUrl" [iconName]="menu.text"></va-icon>
          <span class="menu-item-text">{{ menu.text }}</span>
          <mat-icon class="right-icon" *ngIf="menu.rightIcon">{{ menu.rightIcon }}</mat-icon>
        </a>
        <a
          *ngIf="menu.link && menu.link.external"
          class="menu-item"
          [disabled]="menu.disabled"
          [href]="menu.link.url"
          [target]="menu.link.target"
          [attr.data-pendo]="menu.pendo"
          (click)="onClick(menu)"
          [glxyTooltip]="menu.toolTip || ''"
          mat-menu-item
        >
          <mat-icon *ngIf="menu.leftIcon">{{ menu.leftIcon }}</mat-icon>
          <va-icon *ngIf="menu.leftIconImageUrl" [iconUrl]="menu.leftIconImageUrl" [iconName]="menu.text"></va-icon>
          <span>{{ menu.text }}</span>
          <mat-icon class="right-icon" *ngIf="menu.rightIcon">{{ menu.rightIcon }}</mat-icon>
        </a>
      </ng-container>
    </mat-menu>
  `,
})
export class VaMenuComponent {
  @Input() config: Menu;

  onClick(menuItem: MenuItem): void {
    if (menuItem.click) {
      menuItem.click();
    }
  }

  get triggerIcon(): string {
    return this.config.triggerIcon ? this.config.triggerIcon : 'more_vert';
  }

  get title(): string {
    return this.config.title ? this.config.title : '';
  }
}
